import { Card } from '../ui/Card';
import { Skeleton } from '../ui/Skeleton';

interface AINudgeCardProps {
  message: string | null;
  loading?: boolean;
  cta?: React.ReactNode;
}

// AINudgeCard renders the morning nudge if one exists. When the API
// returns null (no nudge generated yet — common for users with <3 days
// of data) we render nothing rather than a hollow accent-bordered card.
// The parent decides whether to mount us; we decide whether we have
// anything to say.
export function AINudgeCard({ message, loading, cta }: AINudgeCardProps) {
  if (!loading && !message) return null;
  return (
    <Card accentLeft className="nudge-card">
      {loading ? (
        <div className="skeleton-stack">
          <Skeleton height={16} />
          <Skeleton height={16} width="80%" />
        </div>
      ) : (
        <p className="nudge-text">{message}</p>
      )}
      {cta ? <div className="nudge-cta">{cta}</div> : null}
    </Card>
  );
}
